import styled from "styled-components"
import { validColor, darkFontColor } from "./helpers"

export const StyledTelephoneWrapper = styled.div`
  display: ${({ hidden }) => (hidden ? "none;" : "grid")}
  margin: .8rem 0;
  width: 100%;
  font-size: 14px;
  background: red;

  & label {
    width: 100%;
    font-size: 14px;
    font-family: 'EFCircularWeb-Book';
    line-height: 1;
    color: #2b2b2b;
    padding: 0 1.6rem 0 0;
    display: flex;
    justify-content: space-between;
    color: ${({ isDark }) => darkFontColor(isDark)};
    @media (max-width: 1024px){
      font-size: 12px;
      padding: 0 1.3rem 0 0;
    }

    & span{
      color: #EE6160;
      font-family: 'EFCircularWeb-Book';
    }
  }

  > div {
    display: flex;
  }
  ${props => props.loading && `
        opacity: .5;
        pointer-events: none;
    `}
`
